import { defineConfig } from "../config";
import { authHeader } from "../helpers";
import { utilsService } from "./utils";
const { handleResponse } = utilsService;

export const historyService = {
  getHistoryBySystemId,
  getHistoryByCampaignId,
  getHistoryByAdvertiserId,
};

const { apiUrl, apiVer, serviceName } = defineConfig.HISTORY_SERVICE;

function getApiPath(){
    const version = (apiVer !== null ? ("/" + apiVer) : "");
    return (apiUrl + version + serviceName);
}

function getHistoryBySystemId(systemId, searchFilters = {}) {
  const newFilters = Object.entries(searchFilters)
  .filter(([, value]) => value !== null && value !== undefined && value !== '')
  .map(([key, value]) => {
    const encodedValue = Array.isArray(value)
      ? encodeURIComponent(value.join(','))
      : encodeURIComponent(value);

    return `${key}=${encodedValue}`;
  })
  .join('&');

  const url = getApiPath() + "/idSystem/" + systemId + "?" + newFilters;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getHistoryByCampaignId(campaignId) {
  const url = getApiPath() + `/idCampaign/${campaignId}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getHistoryByAdvertiserId(advertiserId, searchFilters = {}) {
  const newFilters = Object.entries(searchFilters)
  .filter(([, value]) => value !== null && value !== undefined && value !== '')
  .map(([key, value]) => {
    const encodedValue = Array.isArray(value)
      ? encodeURIComponent(value.join(','))
      : encodeURIComponent(value);

    return `${key}=${encodedValue}`;
  })
  .join('&');

  const url = getApiPath() + "/idAdvertiser/" + advertiserId + "?" + newFilters;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}